import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'mismatch-warning',
  templateUrl: './mismatch-warning.component.html',
  styleUrls: []
})

export class MismatchWarningComponent implements OnInit{

  mismatchWarningStrings: any;
  mismatchWarningStringsEdited: any;
  @Output() continue: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<MismatchWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { 
    }
  
  ngOnInit() {
    this.mismatchWarningStrings = this.data.value;
  }

  close() {
    this.dialogRef.close();
    this.continue.emit(true);
  }

}
